import { converterDataEua } from "_utils/Data";
import { utils, writeFileXLSX } from "xlsx";
import {
  chaveStatusAutorizacaoItem,
  chaveStatusProducaoItem,
} from "../constants/status";
import { IItemLote } from "../interfaces/IItemLote";
import {
  COLUNAS_EXPORTACAO_LOTES,
  IChavesStatus,
  linhaExportacaoPlaca,
} from "./exportarLotesXlsx";

export const COLUNAS_EXPORTACAO_ITENS_LOTE = COLUNAS_EXPORTACAO_LOTES.filter(
  (coluna) => coluna !== "Lote"
);

const CHAVES_STATUS_ITEM: IChavesStatus = {
  autorizacao: chaveStatusAutorizacaoItem,
  producao: chaveStatusProducaoItem,
};

export function linhasExportacaoItensLote(itens: IItemLote[]) {
  return itens.map((item) => linhaExportacaoPlaca(item, CHAVES_STATUS_ITEM));
}

export function exportarItensLoteXlsx(
  idLote: number,
  itens: IItemLote[],
  hoje: Date = new Date()
) {
  const planilha = utils.json_to_sheet(linhasExportacaoItensLote(itens), {
    header: [...COLUNAS_EXPORTACAO_ITENS_LOTE],
  });
  const arquivo = utils.book_new();

  utils.book_append_sheet(arquivo, planilha, "Placas");
  writeFileXLSX(
    arquivo,
    `lote_${idLote}_placas_${converterDataEua(hoje)}.xlsx`
  );
}
